/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Unity(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 16.4528V5.92179L12.8645 0.667969V4.70757L16.4393 6.7624C16.5794 6.83245 16.5794 7.0426 16.4393 7.11265L12.1869 9.56443C12.0701 9.63448 11.9065 9.63448 11.7897 9.56443L7.53738 7.11265C7.3972 7.0426 7.3972 6.83245 7.53738 6.7624L11.1121 4.70757V0.667969L2 5.92179V16.4528L5.50467 14.4446V10.3116C5.50467 10.1715 5.66822 10.0548 5.80841 10.1482L10.0607 12.6C10.1776 12.67 10.271 12.8101 10.271 12.9502V17.8538C10.271 17.9939 10.1075 18.1106 9.96729 18.0172L6.39252 15.9624L2.88785 17.9705L12 23.2244L21.1122 17.9705L17.6075 15.9624L14.0327 18.0172C13.9159 18.0873 13.729 17.9939 13.729 17.8538V12.9502C13.729 12.8101 13.7991 12.67 13.9393 12.6L18.1916 10.1482C18.3084 10.0781 18.4953 10.1715 18.4953 10.3116V14.4446L22 16.4528Z"
        fill="#4C4C4C"
      />
      <path
        d="M12 23.2244L21.1122 17.9706L17.6075 15.9625L14.0327 18.0173C13.9159 18.0874 13.729 17.994 13.729 17.8539V12.9503C13.729 12.8102 13.7991 12.6701 13.9393 12.6001L18.1916 10.1483C18.3084 10.0782 18.4953 10.1716 18.4953 10.3117V14.4447L22 16.4529V5.92188L12 11.6894V23.2244Z"
        fill="black"
      />
      <path
        d="M12.8645 0.667969V4.70757L16.4393 6.7624C16.5794 6.83245 16.5794 7.0426 16.4393 7.11265L12.1869 9.56443C12.0701 9.63448 11.9065 9.63448 11.7897 9.56443L7.53738 7.11265C7.3972 7.0426 7.3972 6.83245 7.53738 6.7624L11.1121 4.70757V0.667969L2 5.92179L12 11.6893L22 5.92179L12.8645 0.667969Z"
        fill="#808080"
      />
      <path
        d="M9.94393 18.0173L6.36916 15.9625L2.86449 17.9706L11.9766 23.2244V11.6894L2 5.92188V16.4529L5.50467 14.4447V10.3117C5.50467 10.1716 5.66822 10.0549 5.80841 10.1483L10.0607 12.6001C10.1776 12.6701 10.271 12.8102 10.271 12.9503V17.8539C10.2477 17.994 10.0841 18.0874 9.94393 18.0173Z"
        fill="#4C4C4C"
      />
    </svg>
  )
}

Unity.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Unity
